import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {gaInit} from './analytics';

import './index.css';

console.log(`Running in ${process.env.NODE_ENV} mode and targeting the ${process.env.REACT_APP_TARGET} environment.`)

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('service-worker.js').then(function(reg) {
    reg.onupdatefound = function() {
    var installingWorker = reg.installing;

    installingWorker.onstatechange = function() {
    switch (installingWorker.state) {
        case 'installed':
          if (navigator.serviceWorker.controller) {
            console.log('New or updated content is available.');
            window.location = window.location.origin;
          } else {
            console.log('Content is now available offline!');
          }
          break;

        case 'redundant':
          console.error('The installing service worker became redundant.');
          break;

        default:  
          console.error(`Unhandled state ${installingWorker.state}`);
        }
      };
    };
  }).catch(function(e) {
    console.error('Error during service worker registration:', e);
  });
}


ReactDOM.render(<App />, document.getElementById('root'));

setTimeout(() => gaInit(), 1000);



// WEBPACK FOOTER //
// ./src/index.js